import { DocumentSubType } from "@/briefpoint-client";
import { getSubTypeText } from "@/lib/utils";

// map DocumentSubType (numeric) to API documentOverrides key (string). only sub types that support overrides.
export function getDocumentOverrideKey(
  subType: DocumentSubType | undefined,
): string | undefined {
  if (subType === undefined) return undefined;
  const key = DocumentSubType[subType] as string | undefined;
  if (!key || key === "Unknown" || key === "Complaint" || key === "Petition")
    return undefined;
  return key;
}

export function buildLibraryDocumentSubTypeSidebarLabels(
  jurisdictionId: string,
  options: { includeFormInterrogatories: boolean },
): Record<number, string> {
  const labels: Record<number, string> = {
    [DocumentSubType.SpecialInterrogatories]: getSubTypeText(
      DocumentSubType.SpecialInterrogatories,
      jurisdictionId,
    ).plural,
    [DocumentSubType.RequestsForProduction]: getSubTypeText(
      DocumentSubType.RequestsForProduction,
      jurisdictionId,
    ).plural,
    [DocumentSubType.RequestsForAdmission]: getSubTypeText(
      DocumentSubType.RequestsForAdmission,
      jurisdictionId,
    ).plural,
  };
  if (options.includeFormInterrogatories) {
    labels[DocumentSubType.FormInterrogatories] = getSubTypeText(
      DocumentSubType.FormInterrogatories,
      jurisdictionId,
    ).plural;
  }
  return labels;
}
